import moment from "moment";
import { createDataObject } from "./helper";
import { getArchiveCastDetails } from "../services/Archive";
import { introductionByAliasAPI } from "../services/Archive";


export async function fetchArchiveDetails(masterlistAlias,setCastCrewData,setArchiveLoader,setFilmData,setProducerData) {
  try {
        setArchiveLoader(true)
        const castData= await getArchiveCastDetails(masterlistAlias);

        const filmData= [];
        const keysToFindForFilmData = ["titlewithLink", "sortable_year", "country_of_origin_film", "language"];
        keysToFindForFilmData.forEach(key => {
          const item = castData?.data?.[0]?.find?.(item => item.key === key);
          if (item) filmData.push(item);
        });
        setFilmData(filmData);

        const producerData= [];
        const keysToFindForProducerData = ["producer", "banner", "director"];
        keysToFindForProducerData.forEach(key => {
          const item = castData?.data?.[0]?.find?.(item => item.key === key);
          if (item) producerData.push(item);
        });

        setProducerData(producerData);
        setArchiveLoader(false)

        if (castData?.data?.[0]) {
          // These keys need to remove bcoz we already showing these values on page
          const keysToRemove = ["titlewithLink", "sortable_year", "alias", "producer", "director", "banner"]; // Add the keys you want to remove
          setCastCrewData(
            castData?.data[0]?.map((item) => {
              if (!keysToRemove.includes(item?.key)) { // Check if the key is not in keysToRemove
                return {
                  display: item?.display,
                  anothervalue: item?.value,
                  key: item?.key
                };
              }
              return null; // Skip the keys that are in keysToRemove
            })
            .filter(Boolean) // Filter out null values
          );
        } else {
          // Handle the case when castData.data[0] is undefined
          setCastCrewData([]);
        }
  } catch (error) {
    console.error('Error fetching data:', error);
    setArchiveLoader(false);
    setCastCrewData([]);

  }
}

export async function fetchResearchCategoryDetails(categoryAlias, researchCategoriesData) {
  try {
    const categoryData = await introductionByAliasAPI("search", categoryAlias);
    
    if (categoryData && categoryData?.[0]) {
      const categoryDetails = {
        alias: categoryData[0]?.find((item) => item.key === "alias")?.value,
        name: categoryData[0]?.find((item) => item.key === "name")?.value,
      };

      researchCategoriesData.push(categoryDetails);
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

  export function formatDateRange(dateOfBirth, dateOfDeath) {
    const birthDate = moment(dateOfBirth);
    const deathDate = moment(dateOfDeath);

    // If both birth and death dates are available, format as "Day Month Year – Day Month Year"
    if (birthDate.isValid() && deathDate.isValid()) {
        return `(${birthDate.format('D MMMM YYYY')} – ${deathDate.format('D MMMM YYYY')})`;
    }

    // If only the death date is missing, format as "Day Month Year – present"
    if (birthDate.isValid() && !deathDate.isValid()) {
        return `(${birthDate.format('D MMMM YYYY')} – present)`;
    }

    // If only the year is available for both birth and death dates
    if (birthDate.isValid() && !deathDate.isValid()) {
        return `(${birthDate.year()} – present)`;
    }

    // If both birth and death dates are just years
    if (birthDate.isValid() && deathDate.isValid()) {
        return `(${birthDate.year()} – ${deathDate.year()})`;
    }

    return null; // Return null if invalid or missing dates
}

  export const archiveFactor = (item) => {

    const findItem = (items, key) => items?.find(it => it.key === key) || {};
    const getValue = (item, defaultValue = "") => item?.value || defaultValue;
    const getDisplay = (item, defaultValue = "") => item?.display || defaultValue;

    // Helper function to safely trim values
    const safeTrim = (value) => {
      if (value == null) return "";
      const strValue = String(value);
      return strValue.trim();
    };

    const lot_number = findItem(item, "lot_number");
    const auction_house = findItem(item, "auction_house_name");
    const dateOfAuction = findItem(item, "auction_end_date");
    const type_of_creator = findItem(item, "type_of_creator");
    const research_categories = createDataObject([item?.find((nestedItem) => nestedItem?.key === "research_categories") ]);
    const dateOfBirth = findItem(item, "date_of_birth");
    const dateOfBirthValue = getValue(dateOfBirth);
    const dateOfDeath = findItem(item, "date_of_death");
    const dateOfDeathValue = getValue(dateOfDeath);

    // const keywords = createDataObject([item?.find((nestedItem) => nestedItem?.key === "keywords") ]);
    
    const dates = formatDateRange(dateOfBirthValue, dateOfDeathValue);

    const number_of_bids_received = createDataObject([
      item?.number_of_bids_received,
    ]);

    const percentage_over_under_mid_estimate = createDataObject([
      item?.percentage_over_under_mid_estimate,
    ]);

    const artwork_square_inch_rate = createDataObject([
      item?.artwork_square_inch_rate,
    ]);

    const previous_auction_sales = createDataObject([
      item?.previous_auction_sales,
    ]);

    const cagr_based_on_previous_sale = createDataObject([
      item?.cagr_based_on_previous_sale,
    ]);

    const coverImage = item?.find((nestedItem) => nestedItem?.key === "direct_url_of_cover_image")?.value;
    const previewImage = item?.find((nestedItem) => nestedItem?.key === "direct_url_of_preview_image")?.value;
    const documentType = findItem(item, "document_type");
    const documentTypeVal = getValue(documentType);

    let estimates = ""
    let winningBid = "";

    const isArtsDocument = documentTypeVal.includes("ARTS");

    if (!isArtsDocument)
    {
      const lowerEstimate = findItem(item, "le_inr");
      const lowerEstimateUsd = findItem(item, "le_usd");
      const higherEstimate = findItem(item, "he_inr");
      const higherEstimateUsd = findItem(item, "he_usd");

      const lowerEstimateInr = safeTrim(lowerEstimate?.value);
      const higherEstimateInr = safeTrim(higherEstimate?.value);
      const lowerEstimateUsdVal = safeTrim(lowerEstimateUsd?.value);
      const higherEstimateUsdVal = safeTrim(higherEstimateUsd?.value);

      const estimationInr = 
      lowerEstimateInr && higherEstimateInr
      ? `${lowerEstimateInr} - ${higherEstimateInr}`
      : lowerEstimateInr
      ? `${lowerEstimateInr}`
      : higherEstimateInr
        ? `${higherEstimateInr}`
        : ""; // Empty string if both are missing

      const estimationUsd = 
      lowerEstimateUsdVal && higherEstimateUsdVal
      ? `${lowerEstimateUsdVal} - ${higherEstimateUsdVal}`
      : lowerEstimateUsdVal
      ? `${lowerEstimateUsdVal}`
      : higherEstimateUsdVal
        ? `${higherEstimateUsdVal}`
        : ""; // Empty string if both are missing

      estimates = {
        display :  getDisplay(lowerEstimate),
        value_in_inr: `${estimationInr}`,
        valuein_dollar: `${estimationUsd}`
      }

      const sellingPriceINR = findItem(item, "sp_inr");
      const sellingPriceUSD = findItem(item, "sp_usd");
      const sellingPriceInr = safeTrim(sellingPriceINR?.value);
      const sellingPriceUsd = safeTrim(sellingPriceUSD?.value);

      // Check if selling prices are not zero and not empty
      const isValidSellingPrice = 
      sellingPriceInr && 
      sellingPriceInr !== "0" && 
      sellingPriceInr !== "0.00";

      if (isValidSellingPrice) {
        winningBid = {
          display: getDisplay(sellingPriceINR),
          value_in_inr: `${sellingPriceInr}`,
          valuein_dollar: `${sellingPriceUsd}`
        };
      }
    }
      const sqrInchRate = findItem(item, "square_inch_rate_in_inr_terms");
      const provenance = findItem(item, "provenance");
      const content = findItem(item, "quotations_and_other_text");

      // Find the size items
      const sizeItem = findItem(item, "length_cm");
      const sizeItemIn = findItem(item, "length_in");
      const baseItem = findItem(item, "base_cm");
      const baseItemIn = findItem(item, "base_in");

      // Safely get the values and provide a fallback for NaN
      const lengthVal = !isNaN(getValue(sizeItem)) ? getValue(sizeItem) : 0;
      const lengthValIn = !isNaN(getValue(sizeItemIn)) ? getValue(sizeItemIn) : 0;
      const baseVal = !isNaN(getValue(baseItem)) ? getValue(baseItem) : 0;
      const baseValIn = !isNaN(getValue(baseItemIn)) ? getValue(baseItemIn) : 0;

      const formatSize = (length, base, unit) => {
        if (length && base) return `${parseFloat(length).toFixed(2)} x ${parseFloat(base).toFixed(2)} ${unit}`;
        if (length) return `${parseFloat(length).toFixed(2)} ${unit}`;
        if (base) return `${parseFloat(base).toFixed(2)} ${unit}`;
        return '';
      };

      // Construct the size value for inches and centimeters
      const sizeValueIn = formatSize(lengthValIn, baseValIn, 'in');
      const sizeValueCm = formatSize(lengthVal, baseVal, 'cm');

      // Safely construct the sizeValue string
      const sizeValue = [sizeValueIn, sizeValueCm]
        .filter(Boolean)
        .join(" (") + (sizeValueCm ? ")" : "");

      let sizeData = {};

      if (sizeValue) {
        sizeData = {
          display: getDisplay(sizeItem) || "N/A", // Provide a fallback for display
          value: sizeValue || "Unknown size" // Provide a fallback for value
        };
      }

    const creatorNameData = findItem(item, "creator_name");
    const creatorName = getValue(creatorNameData);
    const nationalArtTreasureItem = findItem(item, "national_art_treasure_non_exportable");
    const nationalArtTreasure = safeTrim(nationalArtTreasureItem?.value);

    const mediumArtworkItem = findItem(item, "medium_artwork");
    const mediumArtwork = getValue(mediumArtworkItem) ? mediumArtworkItem : null;

    const actualDateItem = findItem(item, "actual_date");
    const actualDateValue = actualDateItem ? getValue(actualDateItem) : null;

    // Construct the mediumDate string
    const mediumDate = `${mediumArtwork?.value || ''}${actualDateValue ? `, ${actualDateValue}` : ''}`;

    // Update mediumArtwork if it is not null or undefined
    if (mediumArtwork && mediumDate) {
        mediumArtwork.value = mediumDate;
    }

    // const findItem(item, "bibliographic_citation")
    const title = findItem(item, "title") || "";
    
    const venue_location = findItem(item, "place_of_publication_creation");
    const location = venue_location && Object.keys(venue_location).length > 0 
    ? venue_location 
    : "Online";

    const auctionType = location === "Online" ? location : "Offline";
    const isEconomicDocument = documentTypeVal.includes("ECON");

    let venueLocation;
    let typeOfAuction;

    if (isEconomicDocument) {
      venueLocation = location ? {
        display: "Venue / Location",
        value: location
      } : null;
    
      typeOfAuction = auctionType ? {
        display: "Type of auction", 
        value: auctionType
      } : null;
    }
    
    let artistName;

    const commonTitle = `${creatorName}${dates ? ` ${dates}` : ''}${nationalArtTreasure && nationalArtTreasure !== "No" ? ` | ${nationalArtTreasure}` : ''}`;

    if (isArtsDocument)
    {
      artistName = {
        display: "Artist Name",
        value: commonTitle
      };
    }

    const signatureItem = findItem(item, "signature");
    const signatureInscription = getValue(signatureItem) ? signatureItem : null;

    const inscriptionItem = findItem(item, "inscription");
    const inscriptionValue = inscriptionItem ? getValue(inscriptionItem) : null;

    // Construct the mediumDate string
    const signatureInscriptionData = `${signatureInscription?.value || ''}${inscriptionValue ? ` |  ${inscriptionValue}` : ''}`;

    if (signatureInscription && signatureInscriptionData) {
      signatureInscription.value = signatureInscriptionData;
    }

    // Check section 4 have values to don't show blank section with border
    const section4 = [
      lot_number,
      auction_house,
      venueLocation,
      dateOfAuction,
      typeOfAuction, 
      provenance].filter(
      (field) => field && Object.keys(field).length > 0
    );

    // Cine data
    const facialRecognition = findItem(item, "facial_recognition_derived_title_of_artwork");
    const documentTypeFull = findItem(item, "document_type_in_full");
    const actualDate = findItem(item, "actual_date")?.value;
    const featuredArtist = findItem(item, "featured_artist");
    const keywords1 = findItem(item, "keywords1_alias")?.value;
    const keywords2 = findItem(item, "keywords2_alias")?.value;
    const keywords3 = findItem(item, "other_keywords_alias")?.value;
    const copyrightData = findItem(item, "copyright");

    const keywordsData = {
      display: "Keywords",
      value: [keywords1, keywords2, keywords3]
        .filter(keyword => keyword)
        .flatMap(keyword => keyword.split('|'))
    };

    const facialRecognitionVal = actualDate
    ? `${facialRecognition?.value || ''}${facialRecognition?.value ? ', ' : ''}${actualDate}`
    : `${facialRecognition?.value || ''}`;

    // we don't have creator name alias so for temp converting to alias we need to update this code
    const cineTitle = {
      display: type_of_creator?.value,
      value: creatorName,
      alias: creatorName.split(' ').join('-').toLowerCase()
    }

    const facialRecognitionData = {
      key: facialRecognition?.key,
      display: "",
      value: facialRecognitionVal
    }

    const documentTypeData = {
      display: "Document Type",
      value: documentTypeFull?.value,
      alias:documentTypeVal,
      key:documentType?.key
    }

    const featuredArtistData = {
      display: "Featured",
      value: featuredArtist?.value
    }

    const cineData = [
      cineTitle,
      facialRecognitionData,
      documentTypeData
      ].filter(
      (field) => field && Object.keys(field).length > 0
    );
    
    const keywords = [
      keywordsData
    ]

    const featured = [
      featuredArtistData
    ]

   const copyright = [
    copyrightData
   ]
    // Cine data

 
    const essayistData = [
      artistName,
      title,
      mediumArtwork,
      sizeData,
      type_of_creator,
      research_categories,
      signatureInscription].filter(
      (field) => field && Object.keys(field).length > 0
    );
    
    return {
    image: coverImage && coverImage !== "" ? coverImage : previewImage || "",
    listDesc:item?.find((nestedItem) => nestedItem?.key ===
      "bibliographic_caption")?.value ||
      item?.find((nestedItem) => nestedItem?.key ===
        "bibliograhpic_caption")?.value ||
      "",
      publicationYear:item?.find((nestedItem) => nestedItem?.key ===
      "sortable_year")?.value || "N.D",
    imagedesc: item?.find((nestedItem) => nestedItem?.key ===
      "bibliographic_caption")?.value || "",
    alias: item?.find((nestedItem) => nestedItem?.key ===
      "alias")?.value,
    fullImageTitle:item?.find((nestedItem) => nestedItem?.key ===
    "bibliographic_caption")?.value ||
    item?.find((nestedItem) => nestedItem?.key ===
      "bibliograhpic_caption")?.value || commonTitle || "",

    masterlist_alias: item?.find((nestedItem) => nestedItem?.key === "masterlist_alias")?.value,
    cineData,
    featured,
    keywords,
    copyright,
    ...(essayistData.length > 0 ? { essayistData } : {}),
    auctionData: [
      number_of_bids_received,
      percentage_over_under_mid_estimate,
      artwork_square_inch_rate,
      previous_auction_sales,
      cagr_based_on_previous_sale,
    ],
    quotation :[content],
    ...(section4.length > 0 ? { section4 } : {}),
    auction_estimates: [estimates, winningBid, sqrInchRate],
    video_link:item?.find((nestedItem) => nestedItem?.key === "video_link")?.value,
  }
};